module.exports = __webpack_public_path__ + "img/delete_white_line.9eb2bb74.svg";